export default __webpack_public_path__ + "static/media/home-slider-background-right.452c8c38.png";